import { Component, computed, signal, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NotificationService } from '../../notification/notification.service';
import { NavigationService } from '@features/navigation/navigation.service';
import { NavigationItem } from '@models/navigation';
import { DropdownItemComponent } from '@shared/dropdown/dropdown-item.component';
import { DropdownComponent as DropdownComponent_1, DropdownComponent } from '@shared/dropdown/dropdown.component';
import { IconComponent } from '@shared/icon/icon.component';

interface Game extends NavigationItem {
  isActive: boolean;
}

const GAME_BOOKMARKS_KEY = 'skinbet_game_bookmarks';
const MAX_GAMES = 4;

@Component({
  selector: 'app-top-bar-games',
  templateUrl: './top-bar-games.component.html',
  styleUrls: ['./top-bar-games.component.scss'],
  imports: [IconComponent, DropdownComponent_1, DropdownItemComponent, RouterLink],
})
export class TopBarGamesComponent {
  @ViewChild('gamesDropdown') gamesDropdown: DropdownComponent;

  bookmarks = signal<string[]>(this.getInitialBookmarks());

  // games = signal<Game[]>(
  //   this.navigationService.games().map((game) => ({
  //     ...game,
  //     isActive: false,
  //   })),
  // );

  games = computed(() => {
    const navGames = this.navigationService.games();
    const savedGames = this.bookmarks();
    return navGames.map((game) => ({
      ...game,
      isActive: savedGames.includes(game.title),
    }));
  });

  selectedGames = computed(() => {
    return this.games().filter((game) => game.isActive);
  });

  constructor(public navigationService: NavigationService, private notificationsService: NotificationService) {
    // this.initGameBookmarks();
  }

  // initGameBookmarks() {
  //   const gameBookmarks = localStorage.getItem(GAME_BOOKMARKS_KEY);
  //   const savedGames: unknown = gameBookmarks ? JSON.parse(gameBookmarks) : null;

  //   if (Array.isArray(savedGames)) {
  //     this.games.update((games) =>
  //       games.map((game) => ({
  //         ...game,
  //         isActive: savedGames?.includes(game.title) ?? false,
  //       })),
  //     );
  //   }
  // }

  // setGames(game: Game, idx: number) {
  //   const isLimit = this.selectedGames().length >= MAX_GAMES && !game.isActive;

  //   if (isLimit) {
  //     this.notificationsService.error(`You can only select up to 4 games`);
  //     return;
  //   }

  //   this.games.update((games) => {
  //     const newGames = [...games];
  //     newGames[idx] = { ...game, isActive: !game.isActive };
  //     return newGames;
  //   });

  //   localStorage.setItem(GAME_BOOKMARKS_KEY, JSON.stringify(this.selectedGames().map((g) => g.title)));
  // }

  getInitialBookmarks(): string[] {
    const gameBookmarks = localStorage.getItem(GAME_BOOKMARKS_KEY);
    return Array.isArray(gameBookmarks ? JSON.parse(gameBookmarks) : null) ? JSON.parse(gameBookmarks) : [];
  }

  setGames(game: Game) {
    const isLimit = this.selectedGames().length >= MAX_GAMES && !game.isActive;
    if (isLimit) {
      this.notificationsService.error(`You can only select up to 4 games`);
      return;
    }

    let newBookmarks: string[];
    if (game.isActive) {
      newBookmarks = this.bookmarks().filter((title) => title !== game.title);
    } else {
      newBookmarks = [...this.bookmarks(), game.title];
    }
    this.bookmarks.set(newBookmarks);
    localStorage.setItem(GAME_BOOKMARKS_KEY, JSON.stringify(newBookmarks));
  }

  handleOpenGamesDropdown() {
    this.gamesDropdown.toggle(this.gamesDropdown.element.nativeElement);
  }
}
